import { useGetFbFanPageBotQuery } from "../services/facebookApiSlice";

interface IProps {
    characterId: string | undefined;
}
const useFbPageQuery = ({ characterId }: IProps) => {
    const { data, isLoading } = useGetFbFanPageBotQuery(
        {
            character_id: characterId as string,
        },
        { skip: !characterId }
    );
    return { fbFanPageBot: data?.data, isLoading };
};
export default useFbPageQuery;
